import { FC } from "react";
import { FormRowProps } from "./type.ts";
import Label from "./Label.tsx";
import { twMerge } from "tailwind-merge";

const FormRow: FC<FormRowProps> = ({
  label,
  children,
  id,
  errorMessage,
  className = { wrapper: "", label: "", error: "" },
}) => {
  const { text, ...labelProps } = label;
  return (
    <div className={twMerge("flex w-full flex-col gap-4", className.wrapper)}>
      {label && Object.entries(label)?.length > 0 && (
        <Label htmlFor={id}  className={className?.label} {...labelProps}>
          {text}
        </Label>
      )}
      {children}
      {errorMessage && errorMessage?.length > 0 && (
        <p className={twMerge("w-full text-sm text-red-600", className?.error)}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default FormRow;
